import { render, staticRenderFns } from "./ReportType.vue?vue&type=template&id=01ba6464&"
import script from "./ReportType.vue?vue&type=script&lang=js&"
export * from "./ReportType.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports